import { IBusStop, IBusStopData, TransferBusStop } from "./busStop.types";

export class BusStop implements IBusStop {
  id: string;
  number: string;
  name: string;
  shortName?: string;
  order?: number;
  // TODO: LineInfo와 연계되어야 함
  departureTime: string;
  arrivalTime: string;
  isFirstStop: boolean;
  isLastStop: boolean;
  isGetOnStop: boolean;
  isGetOffStop: boolean;
  isTransitStop?: boolean;
  isReturnStop?: boolean;
  isDisplayStop: boolean;
  isOmitted?: boolean;
  isTemp?: boolean;
  shouldShowStreetView?: boolean;
  shouldShowBusStopLayout?: boolean;
  latitude: number;
  longitude: number;
  direction: string;
  // Temp
  lineInfoIds?: Array<string>;
  shouldNotice?: boolean;
  // 몇 분 후 도착
  remainingTimeMin?: number;
  isMyBoardingStop?: boolean;
  distance?: number;
  transferBusStops?: TransferBusStop[];
  transferGuide?: string;
  isFavorite: boolean;
  useBeginDtm: string;
  useEndDtm?: string;

  constructor(data: IBusStopData) {
    this.id = data.id;
    this.number = data.number;
    this.name = data.name;
    this.shortName = data.shortName;
    this.order = data.order;
    this.departureTime = data.departureTime;
    this.arrivalTime = data.arrivalTime;
    this.isFirstStop = data.isFirstStop;
    this.isLastStop = data.isLastStop;
    this.isGetOnStop = data.isGetOnStop;
    this.isGetOffStop = data.isGetOffStop;
    this.isTransitStop = data.isTransitStop;
    this.isReturnStop = data.isReturnStop;
    this.isDisplayStop = data.isDisplayStop;
    this.isOmitted = data.isOmitted;
    this.isTemp = data.isTemp;
    this.shouldShowStreetView = data.shouldShowStreetView;
    this.shouldShowBusStopLayout = data.shouldShowBusStopLayout;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.direction = data.direction;
    // Temp
    this.lineInfoIds = data.lineInfoIds;
    this.shouldNotice = data.shouldNotice;
    // 몇 분 후 도착
    this.remainingTimeMin = data.remainingTimeMin;
    this.isMyBoardingStop = data.isMyBoardingStop;
    this.distance = data.distance;
    this.transferBusStops = data.transferBusStops;
    this.transferGuide = data.transferGuide;
    this.isFavorite = data.isFavorite;
    this.useBeginDtm = data.useBeginDtm;
    this.useEndDtm = data.useEndDtm;
  }

  isPassByStop(): boolean {
    return !this.isGetOnStop && !this.isGetOffStop;
  }
}
